/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class CartAPI extends ApiClient {
  constructor() {
    super('carts', { accountScoped: true, apiVersion: 'v1' });
  }

  getContactCarts(contactId) {
    return axios.get(this.url, { params: { contact_id: contactId } });
  }

  openCart(contactId) {
    return axios.get(`${this.baseUrl()}/carts/open_cart`, {
      params: { contact_id: contactId },
    });
  }

  show(cartId) {
    return axios.get(`${this.url}/${cartId}`);
  }

  addItem(cartId, { variantId, quantity = 1 }) {
    return axios.post(`${this.url}/${cartId}/items`, {
      variant_id: variantId,
      quantity,
    });
  }

  updateItem(cartId, itemId, { quantity }) {
    return axios.patch(`${this.url}/${cartId}/items/${itemId}`, { quantity });
  }

  removeItem(cartId, itemId) {
    return axios.delete(`${this.url}/${cartId}/items/${itemId}`);
  }

  applyDiscount(cartId, code, conversationId) {
    return axios.post(`${this.url}/${cartId}/discount`, {
      code,
      conversation_id: conversationId,
    });
  }

  removeDiscount(cartId, conversationId) {
    return axios.delete(`${this.url}/${cartId}/discount`, {
      data: { conversation_id: conversationId },
    });
  }

  sendCheckoutLink(cartId, { messageText, conversationId } = {}) {
    return axios.post(`${this.url}/${cartId}/send_checkout_link`, {
      message_text: messageText,
      conversation_id: conversationId,
    });
  }

  shippingQuote(cartId, recipientCep) {
    return axios.post(`${this.url}/${cartId}/shipping_quote`, {
      recipient_cep: recipientCep,
    });
  }

  applyShipping(cartId, { serviceCode, name, price, deliveryTime }) {
    return axios.patch(`${this.url}/${cartId}/shipping`, {
      service_code: serviceCode,
      name,
      price,
      delivery_time: deliveryTime,
    });
  }

  newCart(contactId) {
    return axios.post(`${this.baseUrl()}/carts/new_cart`, {
      contact_id: contactId,
    });
  }
}

export default new CartAPI();
